/**
 * Opens the device's native share sheet (Web Share API) when available — on phones this
 * surfaces Messages, WhatsApp, email, AirDrop, contacts, etc. Falls back to copying the
 * link to the clipboard on browsers without Web Share (e.g. desktop Firefox).
 *
 * Returns one of: 'shared' | 'copied' | 'cancelled' | 'error'.
 */
export async function shareOrCopy({ title, text, url }) {
    if (navigator.share) {
        try {
            await navigator.share({ title, text, url });
            return 'shared';
        } catch (err) {
            // User dismissed the share sheet — don't fall back to copy in that case.
            if (err && err.name === 'AbortError') return 'cancelled';
            // Any other share failure falls through to the clipboard.
        }
    }
    try {
        await navigator.clipboard.writeText(url);
        return 'copied';
    } catch {
        return 'error';
    }
}
